import React from 'react'
import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'

import Paths from 'constants/paths'

import useCanViewPage from './hooks/useCanViewPage'


/**
 * Prevents access to protected pages based upon the user's configured
 * visibility (provided by AuthProvider). If a requested page is on
 * the user's "excluded" list, he'll be redirected to back to the
 * dashboard.
 */
export default function GateKeeper({ children }) {
  const {
    canViewPage,
    isLoading,
  } = useCanViewPage()

  if ( isLoading ) {
    return null
  }

  if ( !canViewPage ) {
    return (
      <Navigate to={ Paths.DASHBOARD } />
    )
  }

  return children
}

GateKeeper.propTypes = {
  children: PropTypes.node,
}
